<template>
    <div>
        <div class="heading">
            <secondary-title>Crie sua conta aqui</secondary-title>
            <c-paragraph v-if="modal_register">
                Ao criar uma conta em nossa loja, você poderá passar pelo processo de finalização de {{ isBudgetLayout ? 'orçamento' : 'compra' }} mais rapidamente, visualizar {{ isBudgetLayout ? '' : 'e rastrear' }} seus {{ isBudgetLayout ? 'orçamentos' : 'pedidos' }} em sua conta e muito mais!
            </c-paragraph>
        </div>
        <form @submit.prevent="submit" method="post">
            <c-form-group>
                <input
                    type="email"
                    :style="'font-family:'+$root.$children[0].theme.font_family"
                    name="email_register"
                    v-model="email"
                    class="form-input form-wide mb-2"
                    placeholder="Email"
                    required
                />
            </c-form-group>
            <div v-if="submited && !email" class="required">* Informe o seu email</div>
            <div class="form-footer">
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    type="submit"
                    margin="0px 3rem 0px 0px"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                >
                    Continuar
                </c-button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CButton } from '../Styles/Button/styled'
import { CFormGroup, CParagraph, CSecondaryTitle } from '../Styles/Components/styled'

export default {
    name:'CreateAnAccount',
    components: {
        'c-button': CButton,
        'c-form-group': CFormGroup,
        'c-paragraph': CParagraph,
        'secondary-title': CSecondaryTitle
    },
    props: {
        modal: {
            default: false
        },
        modal_register: {
            default: false
        }
    },
    data() {
        return {
            email: null,
            submited: false,
        }
    },
    methods: {
        ...mapActions("clients", [
            "ActionSetEmailRegister",
            "setListEmployeeTypes",
            "getListEmployeeTypes"
        ]),
        submit() {
            this.submited = true
            if(!this.email) {
                return
            }
            // carregar listagem de tipos de funcionários
            this.getListEmployeeTypes()
                .then(response => {
                    this.setListEmployeeTypes(response.data)
                }).catch(error => {
                    console.log(error)
                })

            this.ActionSetEmailRegister(this.email)
            if(this.modal && this.modal_register) {
                this.$root.showModalApp('register_modal')
            }
        }
    },
    computed: {
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        }
    }
}
</script>
